module.exports = __webpack_public_path__ + "img/thumbnail_CommonWombat_j_normal.d67dbb4f.png";